import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APIService } from 'src/app/core/api/general.service';
import { ItineraryService } from '../services/itinerary.service';
import { OperationLogService } from '../services/operation-log.service';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { OptionType } from 'src/app/core/enums/enums';

function loadHistory(
  pnr: string,
  officeId: string,
  country: string,
  gds: string,
  bookingCode: string,
  api: APIService,
  layoutService: LayoutService,
  operationService: OperationLogService,
  itineraryService: ItineraryService
) {
  const loadHistories = forkJoin({
    pnrHistory: api.getPNRHistory(pnr, officeId, country, gds, bookingCode),
    pnrItineraryHistory: api.getPNRItineraryHistory(pnr, officeId, country, gds)
  });

  return loadHistories.pipe(
    map(
      (res) => {
        layoutService.dispatchChangeBreadcrumb(pnr, OptionType.History);
        operationService.dispatchLoadHistorySuccess(res.pnrHistory);
        operationService.dispatchLoadItineraryHistorySuccess(res.pnrItineraryHistory);
        return true;
      },
      catchError((response) => {
        itineraryService.dispatchGenericError(response);
        itineraryService.navigateToWithParams('itinerary/info');
        return of(false);
      })
    )
  );
}

export const PnrHistoryGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const api = inject(APIService);
  const itineraryService = inject(ItineraryService);
  const operationService = inject(OperationLogService);
  const layoutService = inject(LayoutService);

  return loadHistory(
    route?.queryParams?.pnr,
    route?.queryParams?.officeId,
    route?.queryParams?.country,
    route?.queryParams?.gds,
    route?.queryParams?.bookingCode,
    api,
    layoutService,
    operationService,
    itineraryService
  );
};
